import React, { useState } from 'react';
import { DataGrid, esES } from '@material-ui/data-grid';

import { wsUpdate } from 'services/WService';
import { Tooltip } from '@material-ui/core';

export default function UpdatePrice(props) {
  const [pageSize, setPageSize] = useState(10);
  const handlePageSizeChange = (params) => {
    setPageSize(params.pageSize);
  };

  const [dataEdit, setDataEdit] = useState({});
  const [dataEditId, setDataEditId] = useState(null);

  const handleChange = (e) => {
    setDataEdit({ ...dataEdit, [e.field]: e.props.value });
    setDataEditId(e.id);
  };

  async function saveData(dataEditId, dataEdit) {
    if (dataEditId !== null) {
      let response = await wsUpdate('logi/product', dataEditId, dataEdit);
      if (response.success) {
        props.listProducts();
        props.showNotify(response.message);
      } else {
        props.showNotify(response.message, 'error');
      }
    }
  }

  const columns = [
    { field: 'num', headerName: '#', width: 100 },
    { field: 'FrgnName', headerName: 'Cód. producto/proveedor ', width: 250, align: 'right' },
    { field: 'ItemCode', headerName: 'Código', width: 150 },
    { field: 'ItemName', headerName: 'Producto', width: 370 },
    { field: 'last_purchase_price', headerName: 'Ult. precio compra', width: 370 },
    {
      field: 'purchase_price',
      headerName: (
        <Tooltip title="Esta columna es editable" placement="top">
          <span>
            Precio compra <span style={{ color: '#00a1ff', fontSize: '14px' }}>?</span>
          </span>
        </Tooltip>
      ),
      width: 370,
      editable: true
    }
  ];

  return (
    <div style={{ width: '100%', marginTop: '20px' }}>
      <div style={{ height: 650, width: '100%' }}>
        <DataGrid
          localeText={esES.props.MuiDataGrid.localeText}
          columns={columns}
          rows={props.products.map((item, i) => {
            return {
              id: item.id,
              num: i + 1,
              FrgnName: item.FrgnName,
              ItemCode: item.ItemCode,
              ItemName: item.ItemName,
              last_purchase_price: item.last_purchase_price,
              purchase_price: item.purchase_price
            };
          })}
          onEditCellChangeCommitted={() => saveData(dataEditId, dataEdit)}
          onEditCellChange={handleChange}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          rowsPerPageOptions={[10, 20, 100]}
          pagination
        />
      </div>
    </div>
  );
}
